import { Event, EventListener } from "./Event";
import { Layout } from "../components/layout/Layout";

export interface LayoutDataLoadListener extends EventListener<LayoutDataLoadEvent> {
}

export class LayoutDataLoadEvent extends Event<Layout> {
    constructor(target: Layout) {
        super(target);
    }

    public get layout(): Layout {
        return this.target;
    }
}
